import { useEffect,useState } from 'react'
import DateSelectionForm from '../DateSelectionForm'
import {CanadaProvinceList} from '../../app/constants'
import {GetProviceCodeFromName, IsDateInFuture, ValidateString} from '../../app/utils'
import { ERROR_STRING, VALIDATION_ERROR, VALIDATION_TYPE } from '../../app/errors'
import { ErrorWithString } from '../RegularComponents'

const LicenceSuspensionDetailsForm = (props) => {
    const id = props.id + "-licence-suspension"
    const [businessTypeText, setBusinessTypeText] = useState(props.businessLicenceType)
    const [provinceCode, setProvinceCode] = useState(GetProviceCodeFromName(props.province))
    const [suspensionDate, setSuspensionDate] = useState(props.suspensionDate)
    const [reasonText, setReasonText] = useState(props.reason)
    const [action, setAction] = useState(props.action)

    const [showValidationError, setShowValidationError] = useState(props.showValidationError)

    const [businessTypeError, setBusinessTypeError] = useState(VALIDATION_ERROR.NO_ERROR)
    const [provinceError, setProvinceError] = useState(VALIDATION_ERROR.NO_ERROR)
    const [dateError, setDateError] = useState(VALIDATION_ERROR.NO_ERROR)
    const [reasonError, setReasonError] = useState(VALIDATION_ERROR.NO_ERROR)
    const [actionError, setActionError] = useState(VALIDATION_ERROR.NO_ERROR)

    const isBusinessTypeValid = () => { 
        if(showValidationError) {
            return (businessTypeError === VALIDATION_ERROR.NO_ERROR)
        }

        return true
    }

    const isProvinceValid = () => { 
        if(showValidationError) {
            return (provinceError === VALIDATION_ERROR.NO_ERROR)
        }

        return true
    }

    const isDateValid = () => { 
        if(showValidationError) {
            return (dateError === VALIDATION_ERROR.NO_ERROR)
        }

        return true
    }

    const isReasonValid = () => { 
        if(showValidationError) {
            return (reasonError === VALIDATION_ERROR.NO_ERROR)
        }

        return true
    }

    const isActionValid = () => { 
        if(showValidationError) {
            return (actionError === VALIDATION_ERROR.NO_ERROR)
        }

        return true
    }

    useEffect(() => {
        
        const validateBusinessType = () => { 
            let ret = ValidateString(businessTypeText, VALIDATION_TYPE.STRING_NON_EMPTY)
            setBusinessTypeError(ret)
            return (ret === VALIDATION_ERROR.NO_ERROR)
        }

        const validateProvince = () => { 
            const ret = ValidateString(provinceCode, VALIDATION_TYPE.STRING_NON_EMPTY)
            setProvinceError(ret)
            return (ret === VALIDATION_ERROR.NO_ERROR)
        }

        const validateDate = () => { 
            let ret = ValidateString(suspensionDate, VALIDATION_TYPE.DATE_VALID)
            
            if(ret === VALIDATION_ERROR.NO_ERROR && IsDateInFuture(suspensionDate)) { 
                ret = VALIDATION_ERROR.DATE_IN_FUTURE
            }

            setDateError(ret)
            return (ret === VALIDATION_ERROR.NO_ERROR)
        }

        const validateReason = () => { 
            let ret = ValidateString(reasonText, VALIDATION_TYPE.STRING_NON_EMPTY)
            setReasonError(ret)
            return (ret === VALIDATION_ERROR.NO_ERROR)
        }

        const validateAction = () => { 
            let ret = ValidateString(action, VALIDATION_TYPE.STRING_NON_EMPTY)
            setActionError(ret)
            return (ret === VALIDATION_ERROR.NO_ERROR)
        }

        setBusinessTypeText(props.businessLicenceType)
        setProvinceCode(GetProviceCodeFromName(props.province))
        setSuspensionDate(props.suspensionDate)
        setReasonText(props.reason)
        setAction(props.action)
        setShowValidationError(props.showValidationError)

        if(props.showValidationError) { 
            validateBusinessType()
            validateProvince()
            validateDate()
            validateReason()
            validateAction()
        }
    },[
        businessTypeText,
        provinceCode,
        reasonText,
        suspensionDate,
        action,
        props.businessLicenceType,
        props.province,
        props.suspensionDate,
        props.reason,
        props.action,
        props.showValidationError
    ])

    const provinceOptionElements = []
    for (const key in CanadaProvinceList) {
        if (Object.hasOwnProperty.call(CanadaProvinceList, key)) {
            const element = CanadaProvinceList[key];
            provinceOptionElements.push(<option key={key} value={key}>{element}</option>)
        }
    }

    const actionOptionElements = ["Select Action","Suspended","Revoked","Refused"].map((action, index) => {
        return (<option key={`action-${index}`} value={action}>{action}</option>)
    })

    return (
        <fieldset className="ns-fieldset"  id={id + "-form"}>
            <div className={"ns-fieldset" + (!isBusinessTypeValid() ? " ns-fieldset-message-error" : "")}>
                <label
                    className="ns-label"
                    id={id + "-business-licence-type-label"}
                    htmlFor={id + "-business-licence-type-text"}>
                        Type of business licence
                </label>
                {!isBusinessTypeValid() && 
                <span id={id + "-business-licence-type-error"} className="ns-error-message field-validation-error">
                    {ErrorWithString(ERROR_STRING.LICENCE_SUSPENSION_BUSINESS_TYPE_EMPTY)}
                </span>}
                <input
                    type="text"
                    className={"fw-20" + (isBusinessTypeValid() ? " ns-input" : " ns-input--error")}
                    id={id + "-business-licence-type-text"}
                    name={id + "-business-licence-type-text"}
                    value={businessTypeText}
                    onChange={(e) => {
                        setBusinessTypeText(e.target.value)
                        props.onDetailsChange({
                            id: props.id,
                            updatedDetails : {
                                businessLicenceType : e.target.value
                            }
                        })
                    }}
                />
            </div>
            <div className={"ns-fieldset" + (!isProvinceValid() ? " ns-fieldset-message-error" : "")}>
                <label 
                    id={id + "-province-select-label"}
                    className="ns-label"
                    htmlFor={id + "-province-select-input"}>
                        Province
                </label>
                {!isProvinceValid() && 
                <span id={id + "-province-select-error"} className="ns-error-message field-validation-error">
                    {ErrorWithString(ERROR_STRING.LICENCE_SUSPENSION_PROVINCE_EMPTY)}
                </span>}
                <div className="select fw-20 inlineDisplay">
                    <select 
                        className={!isProvinceValid() ? "select--error" : ""}
                        style={{width : "20em"}}
                        id={id + "-province-select-input"}
                        name={id + "-province-select-input"}
                        value={provinceCode}
                        onChange={(e) => {
                                setProvinceCode(e.target.value)
                                props.onDetailsChange({
                                    id: props.id,
                                    updatedDetails : {
                                        province : CanadaProvinceList[e.target.value]
                                    }
                                })
                            }}>
                            {provinceOptionElements}
                    </select>
                </div>
            </div>
            <div className={"ns-fieldset" + (!isActionValid() ? " ns-fieldset-message-error" : "")}>
                <label 
                    id={id + "-action-label"}
                    className="ns-label">
                        Licence action
                </label>
                {!isActionValid() && 
                <span id={id + "-action-select-error"} className="ns-error-message field-validation-error">
                    {ErrorWithString(ERROR_STRING.LICENCE_SUSPENSION_ACTION_EMPTY)}
                </span>}
                <div className="select fw-15 inlineDisplay">
                    <select
                        className={!isActionValid() ? "select--error" : ""}
                        style={{width : "15em"}}
                        id={id + "-action-select-input"}
                        name={id + "-action-select-input"}
                        value={action}
                        onChange={(e) => {
                                setAction(e.target.value)
                                props.onDetailsChange({
                                    id: props.id,
                                    updatedDetails : {
                                        action : e.target.value
                                    }
                                })
                            }}>
                            {actionOptionElements}
                    </select>
                </div>
            </div>
            <div className={"ns-fieldset" + (!isDateValid() ? " ns-fieldset-message-error" : "")}>
                <label 
                    id={id + "-start-date-label"}
                    className="ns-label">
                        Suspension date
                </label>
                <DateSelectionForm 
                    id={id + "-start-date"} 
                    date={suspensionDate}
                    showValidationError={showValidationError}
                    disableFutureDate={true}
                    onDateChange={(date) => {
                            setSuspensionDate(date)
                            
                            props.onDetailsChange({
                                id: props.id,
                                updatedDetails : {
                                    suspensionDate : date
                                }
                            })
                        }}
                />
            </div>
            
            <div className={"ns-fieldset" + (!isReasonValid() ? " ns-fieldset-message-error" : "")}>
                <label
                    htmlFor={id+"-reason-input"}
                    className="ns-label"
                    id={id + "-reason-input-label"}>
                        Reason
                </label>
                <div className="help-block">Maximum of 500 characters</div>
                {!isReasonValid() && 
                <span id={id + "-reason-input-error"} className="ns-error-message field-validation-error">
                    {ErrorWithString(ERROR_STRING.LICENCE_SUSPENSION_REASON_EMPTY)}
                </span>}
                <div className={"textarea fw-20 inlineDisplay"}>
                    <textarea
                        className={!isReasonValid() ? "ns-input--error" : "ns-input"}
                        style={{width : "20em"}}
                        id={id + "-reason-input"}
                        rows={4} 
                        cols={60}
                        maxLength={500}
                        value={reasonText || ""}
                        onInput={(e) => {
                            setReasonText(e.target.value)
                            props.onDetailsChange({
                                id: props.id,
                                updatedDetails : {
                                    reason : e.target.value
                                }
                            })
                        }}>
                    </textarea>
                </div>
            </div>
        </fieldset>
    )
}

export default LicenceSuspensionDetailsForm
